import { render } from "./BookIcon.vue?vue&type=template&id=56de65a5"
import script from "./BookIcon.vue?vue&type=script&lang=ts"
export * from "./BookIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script